import Vue from 'vue'

Vue.filter('dollar', (value, symbol = '$', fixed = 2) => {
  if (!value) return `${symbol} 0`
  return `${symbol} ${(+value).toLocaleString(undefined, {minimumFractionDigits: fixed, maximumFractionDigits: fixed})}`
})

Vue.filter('bitcoin', (value, symbol = '₿', fixed = 6) => {
  if (!value) return `${symbol} 0`
  return `${symbol} ${(+value).toLocaleString(undefined, {minimumFractionDigits: fixed, maximumFractionDigits: fixed})}`
})
